import Box from '@mui/system/Box';
import { Button, Typography } from '@mui/material';
import React from 'react';
import { KeyboardArrowLeft } from '@mui/icons-material';

type ProfileBackSnackBarProps = {
  current: string; // Current link.
  handleClick?: () => void;
  open: boolean;
  title?: string;
  styles?: {
    container?: React.CSSProperties;
  };
};

const ProfileBackSnackBar = ({
  current,
  handleClick,
  open,
  title,
  styles,
}: ProfileBackSnackBarProps) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      position: 'fixed',
      transition: 'bottom .3s',
      bottom: open ? '16px' : '-55px',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: '10',
      backgroundColor: 'primary.main',
      borderRadius: '4px',
      padding: '8px 36px',
      ...styles?.container,
    }}
  >
    <Button
      onClick={handleClick}
      sx={{
        color: 'primary.contrastText',
        textTransform: 'capitalize',
        padding: '0',
        textDecoration: 'underline',
      }}
    >
      <KeyboardArrowLeft sx={{ color: 'primary.contrastText' }} fontSize='small' />
      {title || 'Back to previous view'}
    </Button>
    <Typography color='primary.contrastText' sx={{ fontSize: '14px', textTransform: 'Capitalize' }}>
      / {current}
    </Typography>
  </Box>
);

export default ProfileBackSnackBar;
